// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as PlLegendLevel from "../components/PlLegendLevel.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as PositionSquare from "../player/PositionSquare.bs.js";
import * as UnitImageExtended from "common/src/tft-static/UnitImageExtended.bs.js";
import Button from "@mui/material/Button";
import ButtonBase from "@mui/material/ButtonBase";
import OpenInFull from "@mui/icons-material/OpenInFull";

var wrap = CssJs.style([
      CssJs.display("flex"),
      CssJs.paddingTop(CssJs.px(2)),
      CssJs.marginLeft(CssJs.auto),
      T.sm_([
            CssJs.justifyContent(CssJs.flexEnd),
            CssJs.paddingTop(CssJs.zero)
          ])
    ]);

var count = "font-medium pl-[2px] font-semibold font-montserrat";

var countSmall = "font-medium pl-[2px] font-semibold font-montserrat text-[14px]";

var Styles = {
  wrap: wrap,
  count: count,
  countSmall: countSmall
};

function WrappedMatchSummary$TraitsRow(Props) {
  var smallOpt = Props.small;
  var traits = Props.traits;
  var small = smallOpt !== undefined ? smallOpt : false;
  var set = TftSet.use(undefined);
  ScreenAtom.use(undefined);
  var traits$1 = traits.length > 7 ? Belt_Array.keep(traits, (function (param) {
            return !Sd.isTraitUnique(param[0], set);
          })) : traits;
  return React.createElement("div", {
              className: wrap
            }, Belt_Array.mapWithIndex(Belt_SortArray.stableSortBy(traits$1, (function (param, param$1) {
                        var r2 = param$1[1];
                        var t2 = param$1[0];
                        var r1 = param[1];
                        var t1 = param[0];
                        var s1 = Sd.traitStyle(t1, r1, set);
                        var s2 = Sd.traitStyle(t2, r2, set);
                        var c1 = Sd.traitRankUnitCount(t1, r1, set);
                        var c2 = Sd.traitRankUnitCount(t2, r2, set);
                        var c = Caml.caml_int_compare(s2, s1);
                        if (c !== 0) {
                          return c;
                        } else {
                          return Caml.caml_int_compare(c2, c1);
                        }
                      })), (function (idx, param) {
                    var rank = param[1];
                    var traitId = param[0];
                    var count$1 = Sd.traitRankUnitCount(traitId, rank, set);
                    return React.createElement(TraitTooltip.make, {
                                trait: traitId,
                                rank: rank,
                                children: React.createElement("div", {
                                      className: "flex items-center select-none" + (
                                        idx === 0 ? "" : (
                                            small ? " ml-[5px]" : " ml-[6px]"
                                          )
                                      )
                                    }, React.createElement(TraitImage.PlainIcon.make, {
                                          traitId: traitId,
                                          rank: rank,
                                          size: small ? 16 : 18
                                        }), React.createElement("div", {
                                          className: small ? countSmall : count
                                        }, String(count$1))),
                                key: String(idx)
                              });
                  })));
}

var TraitsRow = {
  Styles: Styles,
  make: WrappedMatchSummary$TraitsRow
};

var wrap$1 = "px-[6px] sm:px-2 pt-2 pb-1 sm:pb-2 elevation-2 w-full sm:rounded";

var topRow = CssJs.merge([
      "flex items-center pb-1 mb-3 sm:mb-4",
      CssJs.style([
            CssJs.height(CssJs.px(47)),
            CssJs.borderBottom(CssJs.px(1), CssJs.solid, CssJs.rgba(255, 255, 255, {
                      NAME: "num",
                      VAL: 0.6
                    })),
            T.sm_([CssJs.height(CssJs.auto)])
          ])
    ]);

var expandButton = CssJs.style([
      CssJs.color(CssJs.rgba(255, 255, 255, {
                NAME: "num",
                VAL: 0.87
              })),
      CssJs.fontSize(CssJs.px(20)),
      CssJs.minWidth(CssJs.px(32)),
      CssJs.maxWidth(CssJs.px(32))
    ]);

var unitsGrid = CssJs.style([
      CssJs.justifyContent(CssJs.center),
      CssJs.display(CssJs.grid),
      CssJs.width(CssJs.pct(100)),
      CssJs.gridTemplateColumns([{
              NAME: "repeat",
              VAL: [
                "autoFill",
                CssJs.px(45)
              ]
            }]),
      CssJs.gridGap(CssJs.px(8)),
      CssJs.gridRowGap(CssJs.px(16)),
      T.sm_([
            CssJs.paddingTop(CssJs.zero),
            CssJs.justifyContent("flexStart")
          ])
    ]);

var topRowContents = CssJs.merge([
      "flex-1 text-sm flex flex-col sm:flex-row sm:items-center px-1 pr-2 sm:pr-1 overflow-hidden",
      CssJs.style([
            CssJs.fontFamily({
                  NAME: "custom",
                  VAL: "Montserrat"
                }),
            CssJs.fontWeight({
                  NAME: "num",
                  VAL: 500
                })
          ])
    ]);

var Styles$1 = {
  wrap: wrap$1,
  topRow: topRow,
  expandButton: expandButton,
  unitsGrid: unitsGrid,
  topRowContents: topRowContents
};

function WrappedMatchSummary(Props) {
  var heroParticipant = Props.heroParticipant;
  var onShowDetails = Props.onShowDetails;
  var screenSize = ScreenAtom.use(undefined);
  var set = TftSet.use(undefined);
  var traits = Belt_Array.keepMap(heroParticipant.info.traits, (function (t) {
          if (t.currentTier > 0) {
            return [
                    t.name,
                    t.currentTier
                  ];
          }
          
        }));
  var match = heroParticipant.rankBefore;
  var match$1 = heroParticipant.rankAfter;
  var rankChange = match !== undefined && match$1 !== undefined ? (LpChartUtils.divisionToBase(match$1[0], set) + match$1[1] | 0) - (LpChartUtils.divisionToBase(match[0], set) + match[1] | 0) | 0 : undefined;
  var el = React.createElement("div", {
        className: "px-1"
      }, React.createElement(PositionSquare.make, {
            size: 32,
            pl: heroParticipant.info.placement,
            queueId: heroParticipant.queueId
          }));
  var boardValue = String(PlUtils.calcBoardValue(heroParticipant.info.units, set));
  var el$1 = React.createElement("div", {
        className: "px-2"
      }, React.createElement(PositionSquare.make, {
            pl: heroParticipant.info.placement,
            queueId: heroParticipant.queueId
          }));
  return React.createElement(ButtonBase, {
              classes: {
                root: CssJs.style([
                      CssJs.width(CssJs.pct(100)),
                      CssJs.cursor(CssJs.auto)
                    ])
              },
              disableRipple: screenSize < 5,
              children: React.createElement(ContentSection.make, {
                    level: 2,
                    className: wrap$1,
                    children: React.createElement("div", {
                          className: "flex w-full overflow-hidden",
                          onClick: (function (param) {
                              if (screenSize >= 5) {
                                return Curry._1(onShowDetails, heroParticipant.id);
                              }
                              
                            })
                        }, React.createElement("div", {
                              className: "w-full"
                            }, React.createElement("div", {
                                  className: topRow
                                }, React.createElement("div", {
                                      className: "flex items-center sm:hidden"
                                    }, rankChange !== undefined ? React.createElement(Tooltip.make, {
                                            title: React.createElement("div", undefined, (
                                                  rankChange > 0 ? "+" : ""
                                                ) + String(rankChange) + "lp"),
                                            children: el
                                          }) : el, React.createElement("div", {
                                          className: "pl-2 pr-3"
                                        }, React.createElement(PlLegendLevel.make, {
                                              companionId: heroParticipant.info.companionId,
                                              level: heroParticipant.info.level
                                            }))), React.createElement("div", {
                                      className: topRowContents
                                    }, React.createElement("div", {
                                          className: "flex items-center"
                                        }, React.createElement("div", {
                                              className: "flex items-center gap-[6px] pr-2"
                                            }, Belt_Array.map(Belt_Option.getWithDefault(heroParticipant.info.augments, []), (function (augId) {
                                                    var id = Data.encodeAugmentId(augId);
                                                    return React.createElement(AugmentImage.make, {
                                                                augId: id,
                                                                size: 22
                                                              });
                                                  }))), React.createElement("div", {
                                              className: "ml-auto sm:ml-0 flex items-center"
                                            }, React.createElement(Tooltip.make, {
                                                  title: boardValue + " final board gold value",
                                                  children: React.createElement("div", {
                                                        className: "flex items-center pl-4"
                                                      }, React.createElement("div", {
                                                            className: "pr-[2px]"
                                                          }, boardValue), React.createElement("img", {
                                                            height: "14",
                                                            src: "https://ap.tft.tools/img/general/gold.png?w=14",
                                                            width: "14"
                                                          }))
                                                }), React.createElement(Tooltip.make, {
                                                  title: String(heroParticipant.info.totalDamageToPlayers) + " damage dealt to players",
                                                  children: React.createElement("div", {
                                                        className: "flex items-center ml-4"
                                                      }, React.createElement("div", {
                                                            className: "pr-[2px]"
                                                          }, String(heroParticipant.info.totalDamageToPlayers)), React.createElement("img", {
                                                            height: "14",
                                                            src: "https://ap.tft.tools/img/general/announce_icon_combat.png?w=14",
                                                            width: "14"
                                                          }))
                                                }), React.createElement(Tooltip.make, {
                                                  title: "Round eliminated",
                                                  children: React.createElement("div", {
                                                        className: "ml-4 flex-shrink-0"
                                                      }, heroParticipant.queueId === 1130 ? T.renderHyperrollStageNumber(heroParticipant.info.lastRound) : T.renderStageNumber(heroParticipant.info.lastRound))
                                                }))), React.createElement(WrappedMatchSummary$TraitsRow, {
                                          traits: traits
                                        }), React.createElement("div", {
                                          className: "ml-auto"
                                        }, React.createElement(Button, {
                                              classes: {
                                                root: CssJs.merge([
                                                      "px-[6px]",
                                                      CssJs.style([CssJs.height(CssJs.px(24))])
                                                    ]),
                                                endIcon: CssJs.style([CssJs.marginLeft(CssJs.px(4))])
                                              },
                                              endIcon: React.createElement("svg", {
                                                    height: "14px",
                                                    width: "14px"
                                                  }, React.createElement(OpenInFull, {
                                                        fontSize: "inherit",
                                                        color: "inherit"
                                                      })),
                                              onClick: (function (param) {
                                                  return Curry._1(onShowDetails, heroParticipant.id);
                                                }),
                                              variant: "text",
                                              color: "inherit",
                                              size: "small",
                                              children: "Lobby"
                                            })))), React.createElement("div", {
                                  className: "flex items-center pb-2"
                                }, React.createElement("div", {
                                      className: "hidden sm:flex items-center pb-[2px]"
                                    }, rankChange !== undefined ? React.createElement(Tooltip.make, {
                                            title: React.createElement(React.Fragment, undefined, React.createElement("div", undefined, (
                                                      rankChange > 0 ? "+" : ""
                                                    ) + String(rankChange) + "lp")),
                                            children: el$1
                                          }) : el$1, React.createElement("div", {
                                          className: "pl-2 pr-4"
                                        }, React.createElement(PlLegendLevel.make, {
                                              companionId: heroParticipant.info.companionId,
                                              level: heroParticipant.info.level
                                            }))), React.createElement("div", {
                                      className: unitsGrid
                                    }, Belt_Array.mapWithIndex(Belt_Array.keep(heroParticipant.info.units, (function (u) {
                                                return ![
                                                          "TFT_TrainingDummy",
                                                          "TFT7_TrainerDragon",
                                                          "TFT7_JadeStatue",
                                                          "TFT9_THex",
                                                          "TFT12_Yuumi",
                                                          "TFT_ElderDragon",
                                                          "TFT12_WinterStatue"
                                                        ].includes(u.id);
                                              })), (function (idx, u) {
                                            var items = u.items2;
                                            try {
                                              return React.createElement(UnitImageExtended.make, {
                                                          size: 44,
                                                          sizeMd: 45,
                                                          unitId: u.id,
                                                          starLevel: u.tier,
                                                          items: items,
                                                          unfilteredItems: true,
                                                          key: String(idx)
                                                        });
                                            }
                                            catch (exn){
                                              return null;
                                            }
                                          }))))))
                  })
            });
}

var make = React.memo(WrappedMatchSummary);

export {
  TraitsRow ,
  Styles$1 as Styles,
  make ,
  
}
/* wrap Not a pure module */
